export const CategoryContributorItemType = 'CategoryContributor';
export const CategoryManagerItemType = 'CategoryManager';
